// extracted by css-extract-rspack-plugin
export default {"Box":"base-cell-module__Box__YMXJBlL","editingCell":"base-cell-module__editingCell__PO_xiuR","disallowSelection":"base-cell-module__disallowSelection__kQqHmau"};